import { DATA, KEY, OPTIONAL_KEY, REQUIRED_STRING, Resource } from "shelving";
import { COMMENT_FORM_SCHEMA } from "shared/schema";
import { CONTENT_ENTITY } from "../schema/entity.js";

export const CREATE_COMMENT = new Resource("createComment", DATA({ target: CONTENT_ENTITY, thread: OPTIONAL_KEY, ...COMMENT_FORM_SCHEMA.props }), REQUIRED_STRING);
export const DELETE_COMMENT = new Resource("deleteComment", KEY);
